import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "24", "height": "24", "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "Frame" } }, [_c("path", { attrs: { "id": "Vector", "d": "M12.4895 5.25858L11.5546 5.78718C11.3026 5.92964 11.0013 5.95592 10.7284 5.85925L7.05828 4.55875C6.32422 4.29864 5.58769 4.94039 5.74486 5.70315L6.52523 9.49018C6.5841 9.77587 6.5153 10.073 6.33685 10.3038L3.96988 13.3644C3.49257 13.9815 3.87443 14.8832 4.64981 14.9699L8.51453 15.402C8.8028 15.4342 9.06287 15.59 9.22728 15.829L11.4286 19.0287C11.8692 19.6691 12.84 19.584 13.1624 18.8767L14.7713 15.347C14.8918 15.0827 15.1212 14.8839 15.3999 14.8022L19.3705 13.6382C20.0132 13.4498 20.2018 12.6307 19.7064 12.1802V12.1802", "stroke": "currentColor", "stroke-width": "1.7" } }), _c("path", { attrs: { "id": "Vector_2", "d": "M14.4872 4.12929L15.1531 3.75286V3.75286C15.7384 3.42193 16.4607 3.85698 16.442 4.52912L16.3273 8.63684C16.3191 8.92817 16.4385 9.20856 16.6541 9.40463L17.4452 10.1239L18.0105 10.638", "stroke": "#4791FF", "stroke-width": "1.7", "stroke-linecap": "square" } }), _c("path", { attrs: { "id": "Vector_3", "d": "M17.5 17.5L20.5 20.5", "stroke": "currentColor", "stroke-width": "1.7" } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const BasicBeautyIcon = __component__.exports;
export {
  BasicBeautyIcon as default
};
